import { render } from "./DownLoad.vue?vue&type=template&id=30cdccb3&scoped=true"
import script from "./DownLoad.vue?vue&type=script&lang=js"
export * from "./DownLoad.vue?vue&type=script&lang=js"

import "./DownLoad.vue?vue&type=style&index=0&id=30cdccb3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30cdccb3"]])

export default __exports__